import { useRouter } from "next/navigation"
import React, { useState } from "react"

const PopupButton = () => {
  const router = useRouter()
  const [open, setOpen] = useState(true)
  const onRedirect = () => {
    router.push(process.env.NEXT_PUBLIC_EVENT_BUTTON)
  }
  return (
    <>
      {open && (
        <div className="w-screen h-screen bg-[#00000080] fixed top-0 left-0 z-50 flex items-center justify-center">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[320px] h-[320px] sm:w-[450px] sm:h-[450px] lg:w-[500px] lg:h-[500px] 2xl:w-[600px] 2xl:h-[600px]">
            <img
              onClick={onRedirect}
              className="w-full h-full object-cover cursor-pointer"
              src="/popupButton.png"
              alt=""
            />
            <img
              onClick={() => setOpen(false)}
              className="absolute top-0 right-0 cursor-pointer"
              src="/closeFlyButton.png"
              alt=""
            />
          </div>
        </div>
      )}
    </>
  )
}

export default PopupButton
